var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeHint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 47,
    viewBox: "0 0 42 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0944 10.9504L17.644 3.11628C18.6592 3.39089 19.547 3.97786 20.1119 4.74807C20.6769 5.51828 20.8728 6.40863 20.6566 7.22326L19.5696 11.3187L26.7915 13.2722C27.1623 13.3689 27.5124 13.5292 27.8177 13.742C28.1229 13.9549 28.3759 14.2151 28.5592 14.5048C28.7425 14.7945 28.8517 15.1066 28.8791 15.4196C28.9066 15.7325 28.8517 16.0389 28.7183 16.3173L24.5117 25.0557C24.2898 25.519 23.8626 25.8805 23.3088 26.0735C22.7549 26.2665 22.1118 26.278 21.4978 26.106L7.10513 22.2128M10.0944 10.9504L7.10513 22.2128M10.0944 10.9504L6.68765 10.0289C5.96823 9.82327 5.2127 9.83633 4.56446 10.0656C3.91623 10.2948 3.42043 10.7242 3.17118 11.2724L1.26889 18.4393C1.21327 19.0399 1.42994 19.662 1.87779 20.1877C2.32564 20.7135 2.97349 21.1061 3.69835 21.2912L7.10513 22.2128",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7047 33.2871L40.5679 42.1759L31.7629 44.0569",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3583 37.7832C18.6483 35.7898 21.5187 34.5998 24.5368 34.3925C27.5549 34.1852 30.5573 34.9719 33.0916 36.634L39.4863 41.8911",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeHint);
export default __webpack_public_path__ + "static/media/like_hint.1026914a4a0c4f7a0f73fc90cc3f2469.svg";
export { ForwardRef as ReactComponent };